import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { loadComptes } from "../../store/actions/compteAction";
import { loadLocations } from "../../store/actions/locationAction";
import { loadQuittances, saveQuittance } from "../../store/actions/quittanceAction";
import { loadReglements } from "../../store/actions/reglementAction";
import { loadEcritures, saveEcriture } from "../../store/actions/ecritureAction";
import { saveEmail } from "../../store/actions/emailAction";
import { saveDocument } from "../../store/actions/documentAction";

import FormQuittancement from "../../components/FormQuittancement";

import { TYPE_TAG } from "../../utils/constants";

class Quittancement extends Component {
  componentDidMount() {
    this.props.loadComptes();
    this.props.loadLocations();
    this.props.loadQuittances();
    this.props.loadReglements();
    this.props.loadEcritures();
  }

  render() {
    const {
      utilisateur,
      parametre,
      idLocation,
      comptes,
      journals,
      locations,
      quittances,
      reglements,
      ecritures,
      tags,
    } = this.props;

    return (
      <Spin spinning={!comptes || !locations} size="large" tip="Chargement en cours...">
        <FormQuittancement
          utilisateur={utilisateur}
          parametre={parametre}
          idLocation={idLocation}
          comptes={comptes}
          journals={journals}
          locations={
            locations &&
            locations
              .filter((item) => item.location_etat === "r")
              .sort((a, b) => b.location_id - a.location_id)
          }
          quittances={quittances}
          reglements={reglements}
          ecritures={ecritures}
          tags={tags
            .filter((tag) => tag.tag_type === TYPE_TAG[2].value)
            .sort((a, b) => a.tag_ordre - b.tag_ordre)}
          saveQuittance={this.props.saveQuittance}
          saveEcriture={this.props.saveEcriture}
          saveEmail={this.props.saveEmail}
          saveDocument={this.props.saveDocument}
          addPanesRequete={this.props.addPanesRequete}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadComptes: () => dispatch(loadComptes()),
    loadLocations: () => dispatch(loadLocations()),
    loadQuittances: () => dispatch(loadQuittances()),
    saveQuittance: (jsonData) => dispatch(saveQuittance(jsonData)),
    loadReglements: () => dispatch(loadReglements()),
    loadEcritures: () => dispatch(loadEcritures()),
    saveEcriture: (ecriture) => dispatch(saveEcriture(ecriture)),
    saveEmail: (jsonData) => dispatch(saveEmail(jsonData)),
    saveDocument: (jsonData, dossier, tag) => dispatch(saveDocument(jsonData, dossier, tag)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    parametre: state.parametre.data,
    comptes: state.comptes.data,
    journals: state.journals.data,
    locations: state.locations.data,
    quittances: state.quittances.data,
    reglements: state.reglements.data,
    ecritures: state.ecritures.data,
    tags: state.tags.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quittancement);
